import React from 'react';
import { BarChart3 } from 'lucide-react';

export interface SharedAnalyticsHeaderProps {
  campaignName: string;
  brandName?: string | null;
  brandLogo?: string | null;
  organizationName?: string | null;
  organizationLogo?: string | null;
  orgName?: string | null;
  orgLogo?: string | null;
  isBrand?: boolean;
}

export const SharedAnalyticsHeader: React.FC<SharedAnalyticsHeaderProps> = ({
  campaignName,
  brandName,
  brandLogo,
  organizationName,
  organizationLogo,
  orgName,
  orgLogo,
  isBrand = false,
}) => {
  const resolvedOrgName = organizationName || orgName;
  const resolvedOrgLogo = organizationLogo || orgLogo;

  const [orgLogoError, setOrgLogoError] = React.useState(false);
  const [brandLogoError, setBrandLogoError] = React.useState(false);

  React.useEffect(() => {
    setOrgLogoError(false);
  }, [resolvedOrgLogo]);

  React.useEffect(() => {
    setBrandLogoError(false);
  }, [brandLogo]);

  return (
    <header className="border-b border-gray-200 bg-white">
      <div className="mx-auto flex max-w-[92%] flex-col gap-4 px-6 py-6 sm:grid sm:grid-cols-3 sm:items-center">
        <div className="flex flex-col items-center sm:items-start gap-2">
          {isBrand ? (
            (resolvedOrgName || resolvedOrgLogo) && (
              <div className="flex items-center gap-2">
                {resolvedOrgLogo && !orgLogoError ? (
                  <img
                    src={resolvedOrgLogo}
                    alt={resolvedOrgName || 'Organization'}
                    className="h-10 w-10 rounded-full object-cover border border-gray-200 shadow-sm"
                    onError={() => setOrgLogoError(true)}
                  />
                ) : (
                  <div className="flex h-10 w-10 items-center justify-center rounded-full bg-purple-100 text-purple-700 font-bold text-lg border border-purple-200">
                    {resolvedOrgName?.charAt(0).toUpperCase() || 'O'}
                  </div>
                )}
                {resolvedOrgName && (
                  <span className="font-semibold text-gray-900 text-lg">
                    {resolvedOrgName}
                  </span>
                )}
              </div>
            )
          ) : (
            (brandName || brandLogo) && (
              <div className="flex items-center gap-2">
                {brandLogo && !brandLogoError ? (
                  <img
                    src={brandLogo}
                    alt={brandName || 'Brand'}
                    className="h-10 w-10 rounded-full object-cover border border-gray-200 shadow-sm"
                    onError={() => setBrandLogoError(true)}
                  />
                ) : (
                  <div className="flex h-10 w-10 items-center justify-center rounded-full bg-purple-100 text-purple-700 font-bold text-lg border border-purple-200">
                    {brandName?.charAt(0).toUpperCase() || 'B'}
                  </div>
                )}
                {brandName && (
                  <span className="font-semibold text-gray-900 text-lg">
                    {brandName}
                  </span>
                )}
              </div>
            )
          )}
        </div>
        <div className="text-center">
          <h1 className="text-2xl font-bold text-gray-900">{campaignName}</h1>
        </div>
        <div className="flex flex-col items-center justify-center gap-1.5 sm:items-end sm:justify-end">
          {!isBrand && (resolvedOrgName || resolvedOrgLogo) && (
            <div className="flex items-center gap-2">
              {resolvedOrgLogo && !orgLogoError ? (
                <img
                  src={resolvedOrgLogo}
                  alt={resolvedOrgName || 'Organization'}
                  className="h-9 w-9 rounded-full object-cover border border-gray-200 shadow-sm"
                  onError={() => setOrgLogoError(true)}
                />
              ) : (
                <div className="flex h-9 w-9 items-center justify-center rounded-full bg-purple-100 text-purple-700 font-bold text-base border border-purple-200">
                  {resolvedOrgName?.charAt(0).toUpperCase() || 'O'}
                </div>
              )}
              {resolvedOrgName && (
                <span className="font-semibold text-gray-900 text-base">
                  {resolvedOrgName}
                </span>
              )}
            </div>
          )}
          <div className="flex items-center gap-2">
            <img
              src="/images/Auth-Pages/logo.svg"
              alt="Opsero Logo"
              className={!isBrand && resolvedOrgName ? 'h-6 w-6 object-contain' : 'h-10 w-10 object-contain'}
            />
            <span
              className={`font-['Tilt_Warp'] text-[#350666] ${
                !isBrand && resolvedOrgName ? 'text-[18px]' : 'text-[24px]'
              }`}
            >
              OPSERO
            </span>
          </div>
        </div>
      </div>
    </header>
  );
};

export default SharedAnalyticsHeader;
